import { render, staticRenderFns } from "./recipe_match.vue?vue&type=template&id=63230502&scoped=true&lang=html&"
import script from "./recipe_match.vue?vue&type=script&lang=js&"
export * from "./recipe_match.vue?vue&type=script&lang=js&"
import style0 from "./recipe_match.vue?vue&type=style&index=0&id=63230502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63230502",
  null
  
)

export default component.exports